export default __webpack_public_path__ + "static/media/icon_service_search_vector.2bc6e03e.svg";